import usePortfolio from "../hooks/PortfolioProvider"
import {Chart} from "react-google-charts"
import PortUtils from "../portlibs/PortUtils"
import { usePath } from "../libs/path/PathProvider"
import Summarize from "../models/Summarize"
import { Button } from "@mui/material"
import { ImportExport } from "@mui/icons-material"
import Utils from "../libs/Utils"
import useDateRangeFilter from "../portlibs/DateRangeFilterProvider"

export default function AssetChart(){
    const {query} = usePath()
    const {account,currency,filter} = PortUtils.getFilter(query)
    const {portfolio} = usePortfolio()
    const {end} = useDateRangeFilter()
    let holdings = portfolio.filter(currency, filter, account, false)
    if (!filter || filter?.toUpperCase()=="CASH") holdings.push(portfolio.cash(0, account), portfolio.cash(1, account))
    if (!PortUtils.dateEq(end.toDate(), new Date())) holdings = PortUtils.trimHoldings(holdings, end.toDate().getTime())

    const data = Summarize.graph(holdings, end.toDate())
    data.unshift(["Date", "Asset"])
    const options = {
        title:"Asset",
        legend: {position:"none"},
        curveType: "function"
    }
    const onExport = () => Utils.exportFile(new Blob([Summarize.data(holdings, end.toDate()).join("\n")], {type:"text/csv;charset=utf-8"}), `${portfolio.userId}.csv`)
    // const onExport = () => Summarize.data(holdings).join("\n")
    return <>
        <Chart chartType="Line" height="400px" width="100%" data={data} options={options} className="chart"/>
        <Button variant="text" startIcon={<ImportExport/>} onClick={onExport}>Export</Button>
    </>
}